

import { isSameDay, parseISO } from 'date-fns'

import { useMemo } from 'react'

import { CalendarHeader } from '@/features/calendar/components/header/calendar-header'
import { CalendarMonthView } from '@/features/calendar/components/month-view/calendar-month-view'
import { CalendarDayView } from '@/features/calendar/components/week-and-day-view/calendar-day-view'
import { CalendarWeekView } from '@/features/calendar/components/week-and-day-view/calendar-week-view'

import { useCalendar } from '../contexts/use-calendar'

export function ClientContainer() {
  const { selectedDate, trainings, selectedTrainingId, view } = useCalendar()

  const filteredTrainings = useMemo(() => {
    return trainings.filter((t) => {
      const itemStartDate = new Date(t.startAt)
      const itemEndDate = new Date(t.endAt)

      const monthStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1)
      const monthEnd = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0)

      const isInSelectedMonth = itemStartDate <= monthEnd && itemEndDate >= monthStart
      const isTrainingMatch = selectedTrainingId === 'all' || t.id === selectedTrainingId

      return isInSelectedMonth && isTrainingMatch
    })
  }, [selectedDate, selectedTrainingId, trainings])

  const singleDayTrainings = filteredTrainings.filter((t) => {
    const startDate = parseISO(t.startAt)
    const endDate = parseISO(t.endAt)
    return isSameDay(startDate, endDate)
  })

  const multiDayTrainings = filteredTrainings.filter((t) => {
    const startDate = parseISO(t.startAt)
    const endDate = parseISO(t.endAt)
    return !isSameDay(startDate, endDate)
  })

  return (
    <div className="rounded-xl border">
      <CalendarHeader view={view} data={filteredTrainings} />
      {view === 'month' && (
        <CalendarMonthView
          multiDayTrainings={multiDayTrainings}
          singleDayTrainings={singleDayTrainings}
        />
      )}
      {view === 'week' && (
        <CalendarWeekView
          multiDayTrainings={multiDayTrainings}
          singleDayTrainings={singleDayTrainings}
        />
      )}
      {view === 'day' && (
        <CalendarDayView
          multiDayTrainings={multiDayTrainings}
          singleDayTrainings={singleDayTrainings}
        />
      )}
    </div>
  )
}
